import {
  useQuery,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'

import { fetchDetails as getAssignment } from '@pepper/utils/src/api/assignments/assignments'

interface Argument {
  assignmentId: string
  companyId?: string
  includeActivityLog?: boolean
}

export function useAssignment(
  { assignmentId, companyId, includeActivityLog = false }: Argument,
  config?: UseQueryOptions<Assignment | undefined, Error>
): UseQueryResult<Assignment | undefined, Error> {
  return useQuery({
    queryKey: [
      `/assignments/:${assignmentId}`,
      { companyId, includeActivityLog }
    ],
    queryFn: async () => {
      const response = await getAssignment({
        id: assignmentId,
        companyId,
        includeActivityLog
      })

      if (response.error) {
        throw response.error
      }

      return response.data
    },
    ...config
  })
}
